import { render, staticRenderFns, recyclableRender, components } from "./add-bank-card.vue?vue&type=template&id=3ac0cd4c&scoped=true&"
var renderjs
import script from "./add-bank-card.vue?vue&type=script&lang=js&"
export * from "./add-bank-card.vue?vue&type=script&lang=js&"
import style0 from "./add-bank-card.vue?vue&type=style&index=0&id=3ac0cd4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac0cd4c",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pagesA/pages/add-bank-card/add-bank-card.vue"
export default component.exports